export class ShufflePlayersHistoryEvent {
    constructor(type, players) {
        this.type = type;
        this.players = players;
    }
}
